
<div v-if="entry.modifiedBy">
    {{ entry.modifiedBy }} - {{ modifiedDate }}
</div>
